import React from "react";

const Add = () => {
  return (
    <svg
      version="1.1"
      width="25"
      height="25"
      viewBox="0 0 256 256"
      className="add-scream-icon"
    >
      <g transform="translate(128 128) scale(0.72 0.72)">
        <g transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)">
          <path
            d="M 45 90 c -4.418 0 -8 -3.582 -8 -8 V 8 c 0 -4.418 3.582 -8 8 -8 c 4.418 0 8 3.582 8 8 v 74 C 53 86.418 49.418 90 45 90 z"
            transform=" matrix(1 0 0 1 0 0) "
            style={{ strokeLineup: "round" }}
          />
          <path
            d="M 82 53 H 8 c -4.418 0 -8 -3.582 -8 -8 c 0 -4.418 3.582 -8 8 -8 h 74 c 4.418 0 8 3.582 8 8 C 90 49.418 86.418 53 82 53 z"
            transform=" matrix(1 0 0 1 0 0) "
            style={{ strokeLineup: "round" }}
          />
        </g>
      </g>
    </svg>
  );
};

export default Add;
